function _typeof(obj) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
    }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, 'prototype', { writable: false });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, 'string');
    return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== 'object' || input === null)
        return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || 'default');
        if (_typeof(res) !== 'object')
            return res;
        throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return (hint === 'string' ? String : Number)(input);
}
import utils from './utils';
import { MfunsAdvancedDanmaku } from 'mfuns-advanced-danmaku';
var AdvancedDanmaku = function () {
    function AdvancedDanmaku(player, data) {
        var _this = this;
        _classCallCheck(this, AdvancedDanmaku);
        this.player = player;
        this.data = data;
        this.engine = new MfunsAdvancedDanmaku({
            container: this.player.template.advancedDanmaku,
            getDanmaku: function getDanmaku() {
                return data;
            },
            stageSize: [
                800,
                450
            ],
            autoResize: false
        });
        this.player.on('danmaku_load_end', function () {
            _this.engine.resize();
            _this.engine.reload();
        });
    }
    _createClass(AdvancedDanmaku, [
        {
            key: 'play',
            value: function play() {
                this.engine.play();
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.engine.pause();
            }
        },
        {
            key: 'seek',
            value: function seek() {
                this.engine.seek(this.player.video.currentTime * 1000);
            }
        },
        {
            key: 'load',
            value: function load() {
            }
        },
        {
            key: 'resize',
            value: function resize() {
                this.engine.resize();
            }
        }
    ]);
    return AdvancedDanmaku;
}();
export {
    AdvancedDanmaku as default
};